import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import ProfessorComponent, {ProfessorData} from "../../luiss_components/c69_faculty/professor_component";

interface C79ProfessorData extends ProfessorData {}

class C79Professor extends TemplateComponent<C79ProfessorData> {
    componentRender(data: C79ProfessorData): React.ReactElement<any> {
        return (
            <ProfessorComponent {...data} mini={true} />
        )
    }
}

export default C79Professor;